import request from '@/utils/request'
//客户留言保存
export function saveClientNote(data){
  return request({
    url: '/clientNote/save',
    method: 'post',
    data: data
  })
}

//用户注册
export function registerUser(data){
  return request({
    url: '/interSite/user/register',
    method: 'post',
    data: data
  })
}
//用户登录
export function uponUser(data){
  return request({
    url: '/interSite/user/upon',
    method: 'post',
    data: data
  })
}
//用户基本信息
export function userBasic(data){
  return request({
    url: '/interSite/user/basicInfo',
    method: 'get',
    params: data
  })
}
//用户修改基础信息
export function updateUserBasic(data){
  return request({
    url: '/interSite/user/updateBasic',
    method: 'post',
    data: data
  })
}
//用户修改密码
export function updatePwd(data){
  return request({
    url: '/interSite/user/updatePwd',
    method: 'post',
    data: data
  })
}
